import { useMutation } from "@tanstack/react-query";
import { chatMessagesChain } from "../services/compass.service";
import { IChatMessagesChainRequest, IChatMessagesChainResponse } from "../types/compass.types";

export const useChatMessagesChain = () => {
  return useMutation<IChatMessagesChainResponse, Error, IChatMessagesChainRequest>({
    mutationFn: (data) => chatMessagesChain(data),
  });
};
